import Vue from "vue";

import ElementUI from "element-ui";
import mavonEditor from 'mavon-editor'
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/common/common.scss";
import "@/assets/common/remPc.js";
// import "github-markdown-css";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./http";

import {
  parseTime
} from "@/assets/common/common.js"; //格式化时间
import Pagination from "@/components/Pagination"; //分页

Vue.prototype.axios = axios;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(mavonEditor);
Vue.component('Pagination', Pagination);
Vue.prototype.parseTime = parseTime;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");